import React from 'react';
import SearchParams from '../Elements/SearchParams';
import FreelancerUserSearchParams from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserSearchParams';
import FreelancerUserItem from '../Domain/FreelancerUserItem';
import FreelancerAgencyUserTypesEnum from '../Enums/FreelancerAgencyUserTypesEnum';
import serviceHelper from '../Helpers/serviceHelper';
import OfficeHelper from '../Helpers/ModelHelpers/OfficeHelper';
import AuthService from './authService.js';

class FreelancerUserService extends React.Component {
  static GetFreelancerUserList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    // The office filter is a list of office ids (CD-5311), which ConvertAllPropertyToString would join into one string.
    const officeIds = OfficeHelper.ToOfficeIdList(searchItem.OfficeName);
    searchItem = serviceHelper.ConvertAllPropertyToString(searchItem);
    searchItem.OfficeName = officeIds;
    const searchParams = new SearchParams(
      searchItem,
      FreelancerUserSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/FreelancerUser/GetFreelancerUsers?&searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  // officeId: one office id, or a list of them (the vendor search's office filter).
  static async GetAgencyList(officeId) {
    const searchItem = new FreelancerUserSearchParams();
    searchItem.OfficeName = OfficeHelper.ToOfficeIdList(officeId);
    searchItem.UserType = FreelancerAgencyUserTypesEnum.Agency;

    const searchParams = new SearchParams(searchItem, FreelancerUserSearchParams, 'Id', 'Asc', 1, 1000);

    const result = AuthService.getInstance().CallBackendFunction(
      `/api/FreelancerUser/GetFreelancerUsers?&searchParams=${searchParams.serializeForBackendCall()}`
    );

    return result;
  }

  static GetFreelancerUserById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/FreelancerUser/GetFreelancerUserById/${id}`);
  }

  static GetFreelancerUserServiceTypes() {
    return AuthService.getInstance().CallBackendFunction('/api/FreelancerUser/GetServiceTypesByUserId/');
  }

  static ConvertDBFreelancerUser(Users) {
    const convertedUsers = [];

    if (Users !== null) {
      Users.forEach((item) => {
        const newItem = new FreelancerUserItem(item);
        convertedUsers.push(newItem);
      });
    }

    return convertedUsers;
  }

  static async EditFreelancerUser(editedUser) {
    editedUser = FreelancerUserItem.CorrectingTheTypes(editedUser);

    const url = `api/FreelancerUser/PutFreelancerUser/${editedUser.FreelancerUserId}`;

    return AuthService.getInstance().CallBackendFunctionPut(url, editedUser);
  }

  static async AddNewFreelancerUser(newUser) {
    newUser = FreelancerUserItem.CorrectingTheTypes(newUser);

    const url = 'api/FreelancerUser/PostAsync';

    return AuthService.getInstance().CallBackendFunctionPost(url, newUser);
  }
}

export default FreelancerUserService;
